// AUTO-GENERATED - DO NOT EDIT MANUALLY
// Generated from App\Controller\Dto\Response\AdminGoogleFeedGenerateResponse

export type AdminGoogleFeedGenerateApiResponse = {
	business_count: number;
	entity_descriptor: string;
	entity_data: string;
	action_descriptor: string;
	action_data: string;
	service_descriptor: string;
	service_data: string;
};

export type AdminGoogleFeedGenerate = {
	business_count: number;
	entity_descriptor: string;
	entity_data: string;
	action_descriptor: string;
	action_data: string;
	service_descriptor: string;
	service_data: string;
};

export function hydrateAdminGoogleFeedGenerate(data: AdminGoogleFeedGenerateApiResponse): AdminGoogleFeedGenerate {
	return { ...data };
}